import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const ImportModulePresetModal = ({ isOpen, onClose, presets, onSelect }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose} style={{ color: "#fff" }}>
        Copy Modules
      </ModalHeader>
      <ModalBody>
        <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "16px" }}>
          Choose a system to copy its modules.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {presets.map((preset) => (
            <button
              key={preset.label}
              type="button"
              onClick={() => onSelect(preset)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "12px 16px",
                border: "2px solid #e9d5ff",
                borderRadius: "8px",
                background: "#faf5ff",
                color: "rgb(77, 0, 77)",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {preset.label}
              <i className="fa fa-arrow-right"></i>
            </button>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ImportModulePresetModal;
